import { Component, Input } from "@angular/core"
import { LexTranslateService } from "@app/core/services/lex-translate.service"
import { StatusLegend } from "@app/shared/interfaces/status-legend"

@Component({
  selector: "seb-status-legend",
  templateUrl: "./status-legend.component.html",
  styleUrls: ["./status-legend.component.css"],
})
export class StatusLegendComponent {
  @Input() statusLegend: StatusLegend[]

  constructor(public lextranslate: LexTranslateService) {}
}
